// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{overflow:hidden}.root.dragged{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.root.dragged .grid-container .top{pointer-events:auto!important}.root.dragged *{pointer-events:none!important;-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.root.left{cursor:ew-resize!important}.root.right{cursor:ns-resize!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
